module.exports = __webpack_public_path__ + "img/icon-facebook_v2.8dc1afb1.svg";